export const categories = [
  {
    id: "1",
    slug: "ropa",
    name_es: "Ropa",
    name_en: "Clothing",
    image:
      "https://images.unsplash.com/photo-1558171813-4c088753af8f?w=600",
    description_es: "Prendas artesanales con diseños caribeños",
    description_en: "Handcrafted clothing with Caribbean designs",
  },
  {
    id: "2",
    slug: "accesorios",
    name_es: "Accesorios",
    name_en: "Accessories",
    image:
      "https://images.unsplash.com/photo-1611085583191-a3b181a88401?w=600",
    description_es: "Complementos únicos inspirados en Colombia",
    description_en: "Unique accessories inspired by Colombia",
  },
  {
    id: "3",
    slug: "bolsos",
    name_es: "Bolsos",
    name_en: "Bags",
    image:
      "https://images.unsplash.com/photo-1590874103328-eac38a683ce7?w=600",
    description_es: "Bolsos artesanales wayuu y mochilas",
    description_en: "Handcrafted wayuu bags and backpacks",
  },
  {
    id: "4",
    slug: "libros",
    name_es: "Libros",
    name_en: "Books",
    image:
      "https://images.unsplash.com/photo-1512820790803-83ca734da794?w=600",
    description_es: "Literatura colombiana y Gabriel García Márquez",
    description_en: "Colombian literature and Gabriel García Márquez",
  },
];
